import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { QuestionnaireLookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-questionnaire-picker',
  standalone: true,
  imports: [
    FormsModule,
    AutoCompleteModule
  ],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuestionnairePickerComponent),
      multi: true
    }
  ]
})
export class QuestionnairePickerComponent extends BasePickerComponent<QuestionnaireLookupItem> {
  @Input() matterId: string = '';
  @Input() audience: number[] = [3]; 
  
  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<QuestionnaireLookupItem>> {
    return this.lookupService.getQuestionnaires(undefined, query, this.audience, this.matterId, 20);
  }

  override load(keys: string[]): Observable<ListResult<any>> {
    return this.lookupService.getQuestionnaires(keys);
  }
}
